import { useState, useMemo, useRef, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { INDONESIAN_CITIES } from "@/lib/cities";
import { MapPin, Check } from "lucide-react";

export default function CityAutocomplete({ value, onChange, placeholder = "Ketik nama kota / kabupaten…", testid = "city-input", className = "" }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState(value || "");
  const ref = useRef(null);

  useEffect(() => { setQuery(value || ""); }, [value]);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const filtered = useMemo(() => {
    if (!query) return INDONESIAN_CITIES.slice(0, 12);
    const q = query.toLowerCase();
    return INDONESIAN_CITIES.filter(c => c.toLowerCase().includes(q)).slice(0, 12);
  }, [query]);

  const select = (c) => { onChange(c); setQuery(c); setOpen(false); };

  return (
    <div ref={ref} className={`relative ${className}`}>
      <MapPin className="w-4 h-4 absolute left-3 top-3 text-slate-500 pointer-events-none z-10"/>
      <Input
        data-testid={testid}
        value={query}
        onChange={e => { setQuery(e.target.value); onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        className="pl-9 bg-slate-900/60 border-slate-700 text-white h-11"
      />
      {open && filtered.length > 0 && (
        <div className="absolute top-full left-0 right-0 mt-1 max-h-60 overflow-y-auto bg-slate-900 border border-slate-700 rounded-lg z-50 shadow-2xl">
          {filtered.map(c => (
            <button
              key={c}
              type="button"
              data-testid={`city-option-${c}`}
              onClick={() => select(c)}
              className="w-full text-left px-3 py-2 text-sm text-slate-200 hover:bg-cyan-500/20 hover:text-cyan-200 flex items-center justify-between"
            >
              <span>{c}</span>
              {query === c && <Check className="w-3 h-3 text-cyan-400"/>}
            </button>
          ))}
          {query && !filtered.includes(query) && (
            <div className="px-3 py-2 text-[10px] text-slate-500 border-t border-slate-800">
              Tekan Enter untuk pakai "{query}" custom
            </div>
          )}
        </div>
      )}
    </div>
  );
}
